import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class ControlTime extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);		
		this.setTable = this.setTable.bind(this);

		var aux_date = new Date();

		this.state = {
			health_facilities_id:"",
			start_date 	: "",
			end_date 	: "",
			work_sessions:[],
			work_session_id:"all",
			columns:[
				{title:'Donador'},
				{title:'F. Registro'},
				{title:'F. Signos V.'},
				{title:'Tiempo (hh:mm)'},
				{title:'F. Biometría Hemática'},
				{title:'Tiempo (hh:mm)'},
				{title:'F. HC'},
				{title:'Tiempo (hh:mm)'},
				{title:'F. Extracción'},
				{title:'Tiempo (hh:mm)'},				
				{title:'F. Validación'},
				{title:'Diferencia (hh:mm)'},
				{title:'F. Fraccionamiento'},
				{title:'Diferencia (hh:mm)'},
				{title:'Total (hh:mm)'}
			],
			filename:"Control Tiempos",
			listado:[],
			total:"",
			date_hour:"",
			medical:"",
			total_reg:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({components:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		fetch(Config.default.apiGateway.URL+'work_sessions/by_health_facility?health_facilities_id='+this.state.health_facilities_id, {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					work_sessions: response
				});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			aoColumnDefs: [
				{ "sWidth": "200px", "aTargets": [0] },
			   	{ "sWidth": "100px", "aTargets": [1,2,4,6,8,10,12] },
			],
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						console.log(doc)
                		//doc.content[3].table.widths=["15%","8%","8%","5%","10%","5%","10%", "5%","10%","5%", "5%"];

                		
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
            columnDefs: [{
		        targets: [3,4,5,9,10],
		        className: 'dt-center'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
			ordering:false
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}
	}

	timeConvert(n) {
		var num = n;
		var hours = (num / 60);
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return (rhours < 10 ? rhours : rhours) + ":" +
				(rminutes < 10 ? '0'+rminutes : rminutes) + "";
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					work_sessions_id:this.state.work_session_id
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/times_control',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];
						var obj = []
						var sum_bio = 0, sum_sv = 0, sum_hc = 0, sum_ext = 0, sum_val = 0, sum_frac = 0, sum_tot = 0;
						var prom_bio = 0, prom_sv = 0, prom_hc = 0, prom_ext = 0,prom_val = 0,prom_frac = 0, prom_tot = 0;
						response.map((r, i)=>{
							var register = r.register_date !== null ? r.register_date.split('T')[0] : '';
							var bio = r.bio_date !== null ? r.bio_date : '';
							var sv = r.sv_date !== null ? r.sv_date : '';
							var hc = r.hc_date !== null ? r.hc_date.split('T')[0] : '';
							var extraction = r.extraction_date !== null ? r.extraction_date.split('T')[0] : '';
							var validate = r.validation_date !== null ? r.validation_date.split('T')[0] : '';

							var f_reg = register !== '' ? moment(register+' '+r.register_hour, 'YYYY-MM-DD HH:mm') : '';

							var f_sv = sv !== '' ? moment(sv, 'YYYY-MM-DD HH:mm') : '';
							var t_sv = r.sv_date !== null && r.register_date !== null ? 
										f_sv.diff(f_reg, 'minutes') : '';

							var f_bio = bio !== '' ? moment(bio, 'YYYY-MM-DD HH:mm') : '';
							var t_bio = r.bio_date !== null && r.register_date !== null ? 
										f_bio.diff(f_reg, 'minutes') : '';
							
							var f_hc = hc !== '' ? moment(hc+' '+r.hc_hour, 'YYYY-MM-DD HH:mm') : '';
							var t_hc = r.hc_date !== null && r.register_date !== null ? 
										f_hc.diff(f_reg, 'minutes') : '';

							var f_ext = extraction !== '' ? moment(extraction+' '+r.extraction_hour, 'YYYY-MM-DD HH:mm') : '';
							var t_ext = r.hc_date !== null && r.extraction_date !== null ?
										f_ext.diff(f_hc, 'minutes') : '';

							var f_val = validate !== '' ? moment(validate+' '+r.validation_hour, 'YYYY-MM-DD HH:mm') : '';
							var t_val = r.validation_date !== null && r.extraction_date !== null ?
										f_val.diff(f_ext, 'minutes') : '';

							var f_frac = r.division_parts !== null ? 
									moment(r.division_parts, 'YYYY-MM-DDTHH:mm')
								:''
							var t_frac = r.division_parts !== null && r.validation_date !== null ?
										f_frac.diff(f_ext, 'minutes') : '';

							var total = t_hc+t_ext+t_val+t_frac;

							sum_bio += Math.abs(t_bio);
							sum_sv += Math.abs(t_sv);
							sum_hc += Math.abs(t_hc);
							sum_ext += Math.abs(t_ext);
							sum_val += Math.abs(t_val);
							sum_frac += Math.abs(t_frac);
							sum_tot = Math.abs(sum_hc+sum_ext+sum_val+sum_frac);

							if(t_bio !== '') prom_bio++;
							if(t_sv !== '') prom_sv++;
							if(t_hc !== '') prom_hc++;
							if(t_ext !== '') prom_ext++;
							if(t_val !== '') prom_val++;
							if(t_frac !== '') prom_frac++;
							if(total !== '') prom_tot++;

							
							obj = [
								r.donor_name,
								r.register_date !== null ? f_reg.format('DD/MM/YYYY HH:mm') : '',
								r.sv_date !== null ? f_sv.format('DD/MM/YYYY HH:mm') : '',
								t_sv !== "" ? this.timeConvert(Math.abs(t_sv)) : "",
								r.bio_date !== null ? f_bio.format('DD/MM/YYYY HH:mm') : '',
								t_bio !== "" ? this.timeConvert(Math.abs(t_bio)) : "",
								r.hc_date !== null ? f_hc.format('DD/MM/YYYY HH:mm') :'',
								t_hc !== "" ? this.timeConvert(Math.abs(t_hc)) : "",
								r.extraction_date !== null ? f_ext.format('DD/MM/YYYY HH:mm') :'',
								t_ext !== "" ? this.timeConvert(Math.abs(t_ext)) : "",
								r.validation_date !== null ? f_val.format('DD/MM/YYYY HH:mm') :'',
								t_val !== "" ? this.timeConvert(Math.abs(t_val)) : "",
								r.division_parts !== null ? f_frac.format('DD/MM/YYYY HH:mm') :'',
								t_frac !== "" ? this.timeConvert(Math.abs(t_frac)) : "",
								total !== "" ? this.timeConvert(Math.abs(total)) : ""
							];

							list.push(obj);						
						});

						list.push([
							'',
							'',
							'TOTALES',
							this.timeConvert(sum_bio),
							'',
							this.timeConvert(sum_sv),
							'',
							this.timeConvert(sum_hc),
							'',
							this.timeConvert(sum_ext),
							'',
							this.timeConvert(sum_val),
							'',
							this.timeConvert(sum_frac),
							this.timeConvert(sum_tot)
						])
						
						list.push([
							'',
							'',
							'PROMEDIOS',
							sum_bio > 0 ? this.timeConvert(sum_bio/prom_bio) : "0:00",
							'',
							sum_sv > 0 ? this.timeConvert(sum_sv/prom_sv) : "0:00",
							'',
							sum_hc > 0 ? this.timeConvert(sum_hc/prom_hc) : "0:00",
							'',
							sum_ext > 0 ? this.timeConvert(sum_ext/prom_ext) : "0:00",
							'',
							sum_val > 0 ? this.timeConvert(sum_val/prom_val) : "0:00",
							'',
							sum_frac > 0 ? this.timeConvert(sum_frac/prom_frac) : "0:00",
							sum_tot > 0 ? this.timeConvert(sum_tot/prom_tot) : "0:00"
						])
						

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
						this.setState({
							listado: list,
							total_reg:list.length
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_times_control"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div className="col-xs-12 form-group">
									<span className="span-min">Turno</span>
									<select className="form-control" name="work_session_id" id="work_session_id" 
										value={this.state.work_session_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.work_sessions.map((w, i)=>{
											return <option key={i} value={w.id}>
												{w.value}
											</option>
										})}
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>


								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{<div className="col-xs-12">
									<span>Total de registros: </span><label style={{marginLeft:'5px'}}>{this.state.total_reg}</label>
								</div>}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (ControlTime);